<select [(ngModel)]="evaluacionTipo" (change)="evaluacionTipoChange.emit(evaluacionTipo)" class="form-control">
    <option [ngValue]="undefined">-- Seleccione tipo de evaluación --</option>
    <option *ngFor="let et of config.plataforma.evaluacionTipos" [ngValue]="et">
        {{ et | transformInstrumento: transformacion | capitalize }}
    </option>
</select>
